<template ref="todo">
  <div class="row card borderless-card" style="box-shadow: none">
    <div class="col-12" style="/*padding:0*/">
      <!-- <tabulator-card
        id="theMainTableBoxTransactionDetails"
        :tableData="quickListOptions.data"
        :tableOptions="quickListOptions.options"
        :tableColumns="quickListOptions.columns"
        ref="receiverTable"
        @tabulatorDetails="getTabulatorDetails"
      >
        <template slot="header">
          <div class="row mb-3" style="justify-content: space-between; margin:auto">
            <div class="team-title mt-2">
             
              quickTaskList
            </div>
          </div>
        </template>
      </tabulator-card>
      <tabulator-card
        id="theMainTableBoxTransactionDetails"
        :tableData="everyThingElseOptions.data"
        :tableOptions="everyThingElseOptions.options"
        :tableColumns="everyThingElseOptions.columns"
        ref="senderTable"
        @tabulatorDetails="getTabulatorDetails"
      >
        <template slot="header">
          <div class="row mb-3" style="justify-content: space-between; margin:auto">
            <div class="team-title mt-2">
             
              everyThingElse
            </div>
          </div>
        </template>
      </tabulator-card>-->
      <div class="d-flex" style="padding-top: 10px; padding-bottom: 10px">
        <div class="form-group has-search flex-grow-1">
          <span
            class="fa fa-search form-control-feedback"
            style="margin-top: 0"
          ></span>
          <input
            type="text"
            class="form-control upcoming-tasks-search"
            v-model="searchQuery"
            aria-controls="datatables"
            placeholder="Search Task"
          />
        </div>
        <div class="newTaskParentDiv">
          <!-- <button class="newTask" @click="handleCreateTodo">
            <i class="fa fa-plus" aria-hidden="true"></i>
            New task
          </button>-->
        </div>
      </div>
      <div class="upcoming-tasks-line"></div>
      <div
        class="row"
        style="
          justify-content: space-between;
          margin: auto;
          margin-bottom: 10px;
        "
      >
        <div class="upcoming-tasks-headings">Quick Task List</div>
      </div>
      <div id="theMainTableBoxInvestments" class="todos-table-parent">
        <div id="theMainTableFixerInvestments">
          <div class="tabulator quickTask" ref="receiverTable"></div>
        </div>
      </div>

      <div
        class="row"
        style="
          justify-content: space-between;
          margin: auto;
          padding-top: 37px;
          margin-bottom: 10px;
        "
      >
        <div class="upcoming-tasks-headings">EveryThing Else</div>
      </div>
      <div id="theMainTableBoxInvestments" class="todos-table-parent">
        <div id="theMainTableFixerInvestments">
          <div class="tabulator everyThingElse" ref="senderTable"></div>
        </div>
      </div>
      <dialogtodo
        v-model="dialogTodoData"
        v-if="showDialogModal"
        :refresh="todoData"
      ></dialogtodo>
    </div>
    <el-dialog
      center
      width="354px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="remindOnFlag"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div>Pick a date:</div>
        <datepicker v-model="remindOnDate" :inline="true"></datepicker>
      </div>
      <div class="col-12 d-flex" style="padding-right: 0">
        <div class="col-xl edit-company-action-button-row" style="padding: 0px">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelRemindOn"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleRemindOnEditTodo(remindOnData, remindOnDate)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      center
      width="400px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="deleteFlag"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this To-do?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDeleteTodo"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDeleteTodo(deleteData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Delete
          </button>
        </div>
      </div>
    </el-dialog>
    <custom-menu></custom-menu>
  </div>
</template>
<script>
import { TabulatorCard } from "../../../components/index";
import { mapGetters } from "vuex";
import moment from "moment";
import DialogAddTodo from "../Dialogs/DialogAddTodo";
import api from "../../../axios_api";
import Tabulator from "tabulator-tables";
import { Dialog } from "element-ui";
import Datepicker from "vuejs-datepicker";
import CustomMenu from "../Components/CustomMenu.vue";

export default {
  name: "upcoming-tasks",
  components: {
    TabulatorCard,
    [DialogAddTodo.name]: DialogAddTodo,
    [Dialog.name]: Dialog,
    Datepicker,
    [CustomMenu.name]: CustomMenu,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      showDialogModal: false,
      dialogTodoData: {},
      quickList: [],
      everyThingElse: [],
      todos: [],
      tabulatorSender: null,
      tabulatorReceiver: null,
      searchQuery: "",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      remindOnFlag: false,
      remindOnDate: "",
      remindOnData: {},
      deleteFlag: false,
      deleteData: {},
    };
  },
  watch: {
    todoData: {
      handler: function (nData) {
        if (this.tabulatorSender)
          this.tabulatorSender.replaceData(nData.everyThingList);
        if (this.tabulatorReceiver)
          this.tabulatorReceiver.replaceData(nData.quickTaskList);
      },
    },
    searchQuery: {
      handler: function (newData) {
        this.tabulatorSender.clearFilter(true);
        this.tabulatorSender.setFilter([
          [
            { field: "priority", type: "like", value: this.searchQuery },
            { field: "due_date", type: "like", value: this.searchQuery },
            { field: "action_type", type: "like", value: this.searchQuery },
            { field: "name", type: "like", value: this.searchQuery },
            { field: "task", type: "like", value: this.searchQuery },
          ],
        ]);
        this.tabulatorReceiver.clearFilter(true);
        this.tabulatorReceiver.setFilter([
          [
            { field: "priority", type: "like", value: this.searchQuery },
            { field: "due_date", type: "like", value: this.searchQuery },
            { field: "action_type", type: "like", value: this.searchQuery },
            { field: "name", type: "like", value: this.searchQuery },
            { field: "task", type: "like", value: this.searchQuery },
          ],
        ]);
      },
    },
  },
  mounted() {
    var that = this;
    this.$store
      .dispatch("todo/getTotalTodos", this.$route.params.workspace_id)
      .then((data) => {
        //this.todoData;
        that.tabulatorSender = new Tabulator(
          that.$refs.senderTable,
          that.everyThingElseOptions
        );
        that.tabulatorReceiver = new Tabulator(
          that.$refs.receiverTable,
          that.quickListOptions
        );
      })
      .catch((error) => {
        console.log("upcomming tasks error", error);
      });
    // setTimeout(() => {
    //
    //   this.todoData;
    // }, 1000);
  },
  computed: {
    ...mapGetters("team", ["getAllUsers"]),
    ...mapGetters("todo", ["current_component"]),
    ...mapGetters("todo", ["all_todos"]),
    ...mapGetters("role", ["checkRole"]),
    todoData() {
      var that = this;
      this.quickList = [];
      this.everyThingElse = [];
      this.todos = JSON.parse(JSON.stringify(this.all_todos));
      var teams = this.getAllUsers;
      for (var i = 0; i < this.todos.length; i++) {
        this.todos[i].index = i;
        this.todos[i].assignedName = [];
        this.todos[i].modified = moment(this.todos[i].modified).format(
          "MM/DD/YYYY"
        );
        this.todos[i].due_date = moment(this.todos[i].due_date).format(
          "MM/DD/YYYY"
        );
        this.todos[i].assigned_to =
          typeof this.todos[i].assigned_to == "string"
            ? [this.todos[i].assigned_to]
            : this.todos[i].assigned_to;

        this.todos[i].assigned_to.map((res) => {
          teams.find((item) => {
            if (item.account._id == res) {
              if (item.account.firstName != item.account.lastName) {
                this.todos[i].assignedName.push(
                  `${item.account.firstName} ${item.account.lastName}`
                );
              } else {
                this.todos[i].assignedName.push(item.account.firstName);
              }
            }
            return item.account._id == res;
          });
        });

        this.todos[
          i
        ].task = `${this.todos[i].title} : ${this.todos[i].description}`;

        this.todos[i].name = this.todos[i].assignedName.toString();
        if (
          this.todos[i].is_quick_task &&
          this.todos[i].is_quick_task == true
        ) {
          this.quickList.push(JSON.parse(JSON.stringify(this.todos[i])));
        } else {
          this.everyThingElse.push(JSON.parse(JSON.stringify(this.todos[i])));
        }
      }
      return {
        quickTaskList: this.quickList,
        everyThingList: this.everyThingElse,
      };
    },
    quickListOptions() {
      const self = this;
      return {
        data: this.quickList,
        minHeight: 100,
        layout: "fitColumns",
        placeholder: "Drag Rows Here",
        layoutColumnsOnNewData: true,
        movableRows: true,
        movableRowsConnectedTables: this.$refs.senderTable,
        movableRowsReceiver: "insert",
        movableRowsSender: "delete",
        movableRowsReceived: function (fromRow, toRow, fromTable) {
          //fromRow - the row component from the sending table
          //toRow - the row component from the receiving table (if available)
          //fromTable - the Tabulator object for the sending table
          let todoData = fromRow._row.data;
          todoData.is_quick_task = true;
          api
            .patch("/todo", {
              encrypt: {
                data: {
                  todo: todoData,
                },
              },
            })
            .then((data) => {
              self.$store.dispatch(
                "todo/getAllTodos",
                self.$route.params.workspace_id
              );
              self.$store.getters["todo/componentTodos"](
                self.current_component,
                self.$route.params.workspace_id
              );
              self.$toaster.success("Updated successfully.");
            })
            .catch((error) => {
              console.log("error in movable rows quick task", error);
              self.$toaster.error("Failed to Update Todo..!!");
            });
        },
        tooltips: true,
        // pagination: "local",
        // paginationSize: 20,
        // paginationSizeSelector: true,
        tooltipsHeader: true,
        columns: this.tableColumns,
      };
    },
    everyThingElseOptions() {
      const self = this;
      return {
        data: this.everyThingElse,
        minHeight: 100,
        layout: "fitColumns",
        layoutColumnsOnNewData: true,
        placeholder: "Drag Rows Here",
        movableRows: true,
        movableRowsConnectedTables: this.$refs.receiverTable,
        movableRowsReceiver: "insert",
        movableRowsSender: "delete",
        movableRowsReceived: function (fromRow, toRow, fromTable) {
          //fromRow - the row component from the sending table
          //toRow - the row component from the receiving table (if available)
          //fromTable - the Tabulator object for the sending table
          let todoData = fromRow._row.data;
          todoData.is_quick_task = false;
          api
            .patch("/todo", {
              encrypt: {
                data: {
                  todo: todoData,
                },
              },
            })
            .then((data) => {
              self.$store.dispatch(
                "todo/getAllTodos",
                self.$route.params.workspace_id
              );
              self.$store.getters["todo/componentTodos"](
                self.current_component,
                self.$route.params.workspace_id
              );
              self.$toaster.success("Updated successfully.");
            })
            .catch((error) => {
              console.log("error in movable rows everything else", error);
              self.$toaster.error("Failed to Update Todo..!!");
            });
        },
        tooltips: true,
        pagination: "local",
        paginationSize: 20,
        paginationSizeSelector: true,
        tooltipsHeader: true,
        columns: this.tableColumns,
      };
    },
    tableColumns() {
      const self = this;
      let handleMenu = function (_cell, a, b) {
        let data = _cell.getData();
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Tomorrow",
              handler: () => {
                self.handleRemindOnEditTodo(
                  _cell.getData(),
                  moment
                    .utc(new Date().setDate(new Date().getDate() + 1))
                    .format("YYYY-MM-DD")
                );
              },
            },
            {
              title:
                self.days[
                  new Date(
                    new Date().setDate(new Date().getDate() + 2)
                  ).getDay()
                ],
              handler: () => {
                self.handleRemindOnEditTodo(
                  _cell.getData(),
                  moment
                    .utc(new Date().setDate(new Date().getDate() + 2))
                    .format("YYYY-MM-DD")
                );
              },
            },
            {
              title:
                self.days[
                  new Date(
                    new Date().setDate(new Date().getDate() + 3)
                  ).getDay()
                ],
              handler: () => {
                self.handleRemindOnEditTodo(
                  _cell.getData(),
                  moment
                    .utc(new Date().setDate(new Date().getDate() + 3))
                    .format("YYYY-MM-DD")
                );
              },
            },
            {
              title: "Pick a Date",
              handler: () => {
                self.remindOnData = _cell.getData();
                self.remindOnDate = _cell.getData().remind_on
                  ? moment.utc(_cell.getData().remind_on).format("YYYY-MM-DD")
                  : "";
                self.remindOnFlag = true;
              },
            },
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        if (data.remind_on) {
          return `<img src="static/img/remind-clock.svg" class=""/>`;
        }
        return `<img src="static/img/black-clock.svg" class=""/>`;
      };
      if (self.checkRole != "Guest") {
        return [
          {
            title: "Priority",
            field: "priority",
            sorter: "string",
            minWidth: 120,
            resizable: false,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            formatter: function (cell, formatterParams) {
              let data = cell.getData();
              let priority = cell.getData().priority;
              let response;
              if (priority == "urgent") {
                response = `<div class="badge urgent-priority-pill px-3">${priority}</div>`;
              } else if (priority == "medium") {
                response = `<div class="badge medium-priority-pill px-3">${priority}</div>`;
              } else {
                response = `<div class="badge low-priority-pill px-3">${priority}</div>`;
              }
              return `<img src="static/img/drag-icon.svg" class=""/> ${response}`;
            },
          },
          {
            title: "Due Date",
            field: "due_date",
            sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
              return new Date(a) - new Date(b); //you must return the difference between the two values
            },
            minWidth: 100,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
          },
          {
            title: "Action",
            field: "action_type",
            sorter: "string",
            minWidth: 120,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            resizable: false,
          },
          {
            title: "Assignee",
            field: "name",
            sorter: "string",
            minWidth: 200,
            resizable: false,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
          },
          {
            title: "Task",
            field: "task",
            sorter: "string",
            minWidth: 330,
            resizable: true,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            formatter: function (cell, formatterParams) {
              let data = cell.getData();
              if (new Date() > new Date(data.due_date)) {
                return `<img src="static/img/warning-icon.svg" class=""/> ${data.task}`;
              } else {
                return `${data.task}`;
              }
            },
          },
          {
            title: "",
            field: "",
            sorter: "string",
            width: 20,
            headerSort: false,
            resizable: false,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleStatusEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            formatter: function (cell, formatterParams) {
              let data = cell.getData();
              // return `<i class="far fa-check-circle"></i>`;
              return `<img src="static/img/status-done-icon.svg" class=""/>`;
            },
          },
          {
            title: "",
            field: "",
            sorter: "string",
            width: 20,
            headerSort: false,
            resizable: false,
            // formatter: function(cell, formatterParams) {
            //   let data = cell.getData();
            //   // if (
            //   //   data.remind_on &&
            //   //   moment(new Date(data.remind_on)).format("MM/DD/YYYY") ==
            //   //     moment(new Date()).format("MM/DD/YYYY")
            //   // ) {
            //   //   return `<img src="static/img/remind-clock.svg" class=""/>`;
            //   // }
            //   if (data.remind_on) {
            //     return `<img src="static/img/remind-clock.svg" class=""/>`;
            //   }
            //   return `<img src="static/img/black-clock.svg" class=""/>`;
            // },
            formatter: handleMenu,
            // contextMenu: [
            //   {
            //     label: "Remind On",
            //     disabled: true,
            //     action: function(e, cell) {}
            //   },
            //   {
            //     label: "Tomorrow",
            //     action: function(e, cell) {
            //       self.handleRemindOnEditTodo(
            //         cell.getData(),
            //         moment
            //           .utc(new Date().setDate(new Date().getDate() + 1))
            //           .format("YYYY-MM-DD")
            //       );
            //     }
            //   },
            //   {
            //     label: function(component) {
            //       //component - column/cell/row component that triggered the menu
            //       return self.days[
            //         new Date(
            //           new Date().setDate(new Date().getDate() + 2)
            //         ).getDay()
            //       ];
            //     },
            //     action: function(e, cell) {
            //       self.handleRemindOnEditTodo(
            //         cell.getData(),
            //         moment
            //           .utc(new Date().setDate(new Date().getDate() + 2))
            //           .format("YYYY-MM-DD")
            //       );
            //     }
            //   },
            //   {
            //     label: function(component) {
            //       //component - column/cell/row component that triggered the menu
            //       return self.days[
            //         new Date(
            //           new Date().setDate(new Date().getDate() + 3)
            //         ).getDay()
            //       ];
            //     },
            //     action: function(e, cell) {
            //       self.handleRemindOnEditTodo(
            //         cell.getData(),
            //         moment
            //           .utc(new Date().setDate(new Date().getDate() + 3))
            //           .format("YYYY-MM-DD")
            //       );
            //     }
            //   },
            //   {
            //     label: "Pick a date",
            //     action: function(e, cell) {
            //       self.remindOnData = cell.getData();
            //       self.remindOnDate = cell.getData().remind_on
            //         ? moment.utc(cell.getData().remind_on).format("YYYY-MM-DD")
            //         : "";
            //       self.remindOnFlag = true;
            //     }
            //   }
            // ]
          },
          {
            title: "",
            field: "",
            sorter: "string",
            width: 20,
            headerSort: false,
            resizable: false,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                let data = cell.getData();
                self.deleteData = data;
                self.deleteFlag = true;
              }
            },
            formatter: function (cell, formatterParams) {
              let data = cell.getData();
              return `<img src="static/img/delete-icon.svg" class=""/>`;
            },
          },
        ];
      } else {
        return [
          {
            title: "Priority",
            field: "priority",
            sorter: "string",
            minWidth: 120,
            resizable: false,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            formatter: function (cell, formatterParams) {
              let data = cell.getData();
              let priority = cell.getData().priority;
              let response;
              if (priority == "urgent") {
                response = `<div class="badge urgent-priority-pill px-3">${priority}</div>`;
              } else if (priority == "medium") {
                response = `<div class="badge medium-priority-pill px-3">${priority}</div>`;
              } else {
                response = `<div class="badge low-priority-pill px-3">${priority}</div>`;
              }
              return `<img src="static/img/drag-icon.svg" class=""/> ${response}`;
            },
          },
          {
            title: "Due Date",
            field: "due_date",
            sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
              return new Date(a) - new Date(b); //you must return the difference between the two values
            },
            minWidth: 100,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
          },
          {
            title: "Action",
            field: "action_type",
            sorter: "string",
            minWidth: 120,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            resizable: false,
          },
          {
            title: "Assignee",
            field: "name",
            sorter: "string",
            minWidth: 200,
            resizable: false,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
          },
          {
            title: "Task",
            field: "task",
            sorter: "string",
            minWidth: 330,
            resizable: true,
            cellClick: function (e, cell) {
              if (self.checkRole != "Guest") {
                self.handleEditTodo(
                  cell._cell.row.data,
                  cell._cell.row.data.index
                );
              }
            },
            formatter: function (cell, formatterParams) {
              let data = cell.getData();
              if (new Date() > new Date(data.due_date)) {
                return `<img src="static/img/warning-icon.svg" class=""/> ${data.task}`;
              } else {
                return `${data.task}`;
              }
            },
          },
        ];
      }
    },
    moment() {
      return moment;
    },
  },
  methods: {
    getTabulatorDetails(list) {
      this.tabulator = list;
    },
    handleCreateTodo() {
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: true,
        data: {
          priority: "medium",
          due_date: new Date().setDate(new Date().getDate() + 3),
          //   assigned_to: [this.$route.params.account_id],
          is_quick_task: false,
          status: "New",
        },
        assigned_to: [this.$route.params.account_id],
      };
    },
    handleEditTodo(item, index) {
      let todoData = JSON.parse(JSON.stringify(item));
      this.$store.commit("todo/setTodoIndex", {
        _id: todoData._id,
        index: index,
      });
      this.showDialogModal = true;
      window.sessionStorage.setItem(
        "todoAssignes",
        JSON.stringify(todoData.assigned_to)
      );
      window.sessionStorage.setItem("todoData", JSON.stringify(todoData));
      this.dialogTodoData = {
        isShow: true,
        isCreate: false,
        data: todoData,
        assigned_to: todoData.assigned_to,
      };
    },
    handleStatusEditTodo(item, index) {
      this.$store.commit("todo/setTodoIndex", {
        _id: item._id,
        index: index,
      });
      item.status = "Done";
      api
        .patch("/todo", {
          encrypt: {
            data: {
              todo: item,
            },
          },
        })
        .then((data) => {
          //this.$store.commit("todo/EditTodoData", data.data.encrypt.data);
          this.$store.dispatch(
            "todo/getAllTodos",
            this.$route.params.workspace_id
          );
          this.$store.getters["todo/componentTodos"](
            this.current_component,
            this.$route.params.workspace_id
          );
          this.$toaster.success("Updated successfully.");
        })
        .catch((error) => {
          console.log(error);
          this.$toaster.error("Failed to Update Todo..!!");
        });
    },
    handleRemindOnEditTodo(data, date) {
      data.remind_on = date;
      api
        .patch("/todo", {
          encrypt: {
            data: {
              todo: data,
            },
          },
        })
        .then((data) => {
          //this.$store.commit("todo/EditTodoData", data.data.encrypt.data);
          this.$store.dispatch(
            "todo/getAllTodos",
            this.$route.params.workspace_id
          );
          this.$store.getters["todo/componentTodos"](
            this.current_component,
            this.$route.params.workspace_id
          );
          this.$toaster.success("Updated successfully.");
          this.remindOnFlag = false;
        })
        .catch((error) => {
          console.log(error);
          this.$toaster.error("Failed to Update Todo..!!");
        });
    },
    handleCancelRemindOn() {
      this.remindOnFlag = false;
      this.remindOnDate = "";
      this.remindOnData = {};
    },
    handleCancelDeleteTodo() {
      this.deleteData = {};
      this.deleteFlag = false;
    },
    handleDeleteTodo(data) {
      api
        .delete(`/todo/${data._id}`, {})
        .then((data) => {
          //this.$store.commit("todo/EditTodoData", data.data.encrypt.data);
          this.$store.dispatch(
            "todo/getAllTodos",
            this.$route.params.workspace_id
          );
          this.$store.getters["todo/componentTodos"](
            this.current_component,
            this.$route.params.workspace_id
          );
          this.deleteFlag = false;
          this.$toaster.success("Deleted successfully.");
        })
        .catch((error) => {
          console.log(error);
          this.$toaster.error("Failed to Delete Todo..!!");
        });
    },
  },
};
</script>
<style>
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  margin-top: 4px;
}

.tab-pane {
  padding: 0;
}

.newTask {
  color: #5445f3;
  border-color: #5445f3;
  /* width: 108px !important; */
  height: 30px;
  font-size: 12px;
  line-height: 15px;
  text-transform: capitalize;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #5445f3;
  border-radius: 4px;
  padding-left: 15px;
  padding-right: 15px;
}

.upcoming-tasks-line {
  height: 0px;
  border-bottom: 0.8px solid #ddd;
  opacity: 1;
}

.newTaskParentDiv {
  padding-top: 3px;
  padding-bottom: 3px;
  cursor: pointer;
}

.upcoming-tasks-search {
  width: 203px;
  border: 0;
  background-color: #f2f2f2;
  margin: 0;
}
.todos-table-parent .tabulator-arrow {
  /* display: none !important; */
}

.todos-table-parent .tabulator-header {
  height: 34px;
  line-height: 17px;
}

.todos-table-parent .tabulator .tabulator-header {
  border-bottom: 1px solid #dee2e6;
}

.todos-table-parent .tabulator-row {
  height: 46px;
  line-height: 22px;
}

.todos-table-parent .tabulator-footer {
  border-top: 0;
}

.tabulator
  .tabulator-header
  .tabulator-col
  .tabulator-col-content
  .tabulator-col-title {
  width: auto;
}

.tabulator
  .tabulator-header
  .tabulator-col
  .tabulator-col-content
  .tabulator-col-title {
  text-overflow: ellipsis;
  white-space: initial;
  padding-right: 10px;
  float: left;
  display: block;
}

.tabulator
  .tabulator-header
  .tabulator-col
  .tabulator-col-content
  .tabulator-arrow {
  position: relative;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #bbb;
  float: left;
  display: block;
  margin-top: 5px;
}

.hide-replaced.ws-inputreplace {
  display: none !important;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 0 !important;
}

.vdp-datepicker__calendar .cell.selected:hover {
  background-color: silver !important;
}

.vdp-datepicker__calendar .cell.selected {
  background-color: silver !important;
}
</style>